import { SentryFallback } from 'app/components/SentryFallback';
import Routes from 'container/App/Routes/Routes';
import React, { FC } from 'react';
import { ToastContainer, Zoom } from 'react-toastify';
import { ErrorBoundary } from '@sentry/react';

export const App: FC = () => {
  return (
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
    /* @ts-ignore */
    <ErrorBoundary fallback={() => <SentryFallback />}>
      <Routes />
      <ToastContainer
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        transition={Zoom}
      />
    </ErrorBoundary>
  );
};
